import React, { useEffect, useRef, useState } from 'react';
import { format } from 'date-fns';
import { ChevronDownIcon, ChevronUpIcon, TrashIcon, PrinterIcon, CheckIcon, XMarkIcon, InformationCircleIcon, DocumentDuplicateIcon, ClockIcon, ArrowUturnLeftIcon, ArchiveBoxIcon, PencilSquareIcon, PlusIcon, MagnifyingGlassIcon, DocumentTextIcon } from '@heroicons/react/24/outline';
import { ArrowPathIcon, LinkIcon } from '@heroicons/react/24/solid';
import StatusFilter from '../../components/StatusFilter';
import ReceivedQtyBarGraph from '../../components/ReceivedQtyBarGraph'; // Update import
import { getShippingMethodColor, getStatusColor } from '../../helpers/statusColor';
import { CreateShipping } from '../../components/shipping/CreateShipping';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { addContainerToThePO, addItemsToContainer, addShipmentElement, deleteBox, deleteContainer, deleteShipment, getAllShipments, printAllContainers, printAllPOLabels, printAllProductLabels, printContainerData, printPackingPlan, printPOLabelData, ShipmentsLoadingKeys, syncShipment, undoLastShipmentBatch, updateBox, updateBoxes, updateContainer, updateContainerItem } from '../../slices/shippingSlice';
import { enumStatuses, excludedStatusesForEmail, statuses } from '../../consts/status';
import { LoaderSpinner } from '../../components/LoaderSpinner';
import { useDebounce } from '../../helpers/useDebounce';
import { AIR, enumBoxTypes, SEA } from '../../consts/boxTypes';
import { ConfrimModal } from '../../components/ConfrimModal';
import { OverlayGrayBackground } from '../../components/OverlayGrayBackground';
import { arrayHasItems, filterKeyFromObject, getEstimatedDateByShippingMethod, scrollToTop } from '../../helpers/common';
import { unwrapResult } from '@reduxjs/toolkit';
import printJS from 'print-js';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../consts/general';
import { anyShipmentProductHasBoxes } from "../../helpers/common";
import ShipmentChangeHistoryDrawer from '../../components/shipping/ShipmentChangeHistoryDrawer';
import ReactTooltip from 'react-tooltip';
import { EmailsDropdownMenu } from '../../components/shipping/EmailsDropdownMenu';
import { Pagination } from '../../components/Pagination';
import { BoxDate } from '../../components/shipping/BoxDate';
import { ShippingBulkEditModal } from '../../components/shipping/ShippingBulkEditModal';
import { CreateContainerByShipping } from '../../components/shipping/CreateShippingContainer';
import { usePageReset } from '../../helpers/usePageReset';

const formatDateForInput = (date) => {
  const d = new Date(date);
  if (isNaN(d.getTime())) return '';
  return d.toISOString().split('T')[0];
};

const formatEstimatedDate = (date) => {
  if (!date) return '';
  const dateOnly = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(date));
  const parsedDate = dateOnly
    ? new Date(Number(dateOnly[1]), Number(dateOnly[2]) - 1, Number(dateOnly[3]))
    : new Date(date);
  if (isNaN(parsedDate.getTime())) return '';
  return format(parsedDate, 'MMM d, yyyy');
};

const getEstimatedReceiveDateLabel = ({
  explicitDate,
  edited,
  shippingMethod,
  dateShipped,
  resolvedDate,
  poEstimatedDeliveryDate,
}) => {
  if (explicitDate) return formatEstimatedDate(explicitDate);

  const liveEstimate = edited
    ? getEstimatedDateByShippingMethod(
      edited.shippingMethod || shippingMethod,
      edited.dateShipped || dateShipped
    )
    : '';

  return liveEstimate || formatEstimatedDate(resolvedDate || poEstimatedDeliveryDate) || 'N/A';
};

function Shipping({
  testId,
  testData,
  access,
  marginFromSidebar
}) {
  const navigate = useNavigate();
  const pageParams = window?.location?.search ? new URLSearchParams(window?.location?.search) : null;
  const pageTag = window?.location?.hash ? window?.location?.hash : null;

  const dispatch = useDispatch();
  const {
    shipments,
    pagination,
    syncingShipments,
    isFirstLoadComplete,
    loadingKeys: shipmentLoadingKeys
  } = useSelector((state) => state.shipments)
  const {
    loading: emailIsLoading
  } = useSelector((state) => state.mail);
  const [searchTerm, setSearchTerm] = useState(pageParams?.get('search') || '');
  const [expandedShipments, setExpandedShipments] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isContainerOpen, setIsContainerOpen] = useState(false);
  const [existingContainer, setExistingContainer] = useState(null);
  const [deleteModalOpened, setDeleteModalOpened] = useState(false);
  const [deleteShipmentModalOpened, setDeleteShipmentModalOpened] = useState(false);
  const [syncConfirmModalOpened, setSyncConfirmModalOpened] = useState(false);
  const [openedBulkEditModal, setOpenedBulkEditModal] = useState(false);
  const wrapperTableRef = useRef(null);
  const [syncShipmentId, setSyncShipmentId] = useState("");
  const [syncEmail, setSyncEmail] = useState([]);
  const [boxIdToDelete, setBoxIdToDelete] = useState("");
  const [containerToDelete, setContainerToDelete] = useState("");
  const [deleteContainerModalOpened, setDeleteContainerModalOpened] = useState(false);
  const [shipmentToDelete, setShipmentToDelete] = useState("");
  const [editedBoxes, setEditedBoxes] = useState({});
  const [editedContainers, setEditedContainers] = useState({});
  const [selectedBulkBoxes, setSelectedBulkBoxes] = useState([]);
  const [receiveAllTarget, setReceiveAllTarget] = useState(null);
  const [shipmentHistoryOpen, setShipmentHistoryOpen] = useState(false);
  const [undoShipmentModalOpen, setUndoShipmentModalOpen] = useState(false);
  const [shipmentHistoryRefreshToken, setShipmentHistoryRefreshToken] = useState(0);
  const [shipmentData, setShipmentData] = useState(shipments || []);
  const [printingList, setPrintingList] = useState([]);
  const [currentPage, setCurrentPage] = useState(Number(pageParams?.get('page') || 1));
  const [currentItemsPerPage, setCurrentItemsPerPage] = useState(Number(pageParams?.get('itemsPerPage') || 50));
  const [filters, setFilters] = useState({
    status: pageParams?.get('statuses')?.split(',') || [],
    vendorIds: pageParams?.get('vendorIds')?.split(',') || [],
    eta: pageParams?.get('eta') || ''
  });
  const [vendorOptions, setVendorOptions] = useState([]);
  const [addShadow, setAddShadow] = useState(false);
  const observeRef = useRef(null);
  const [openedDropdownId, setOpenedDropdownId] = useState(null);
  const currentSearchValue = useDebounce(searchTerm, 800);
  const listParams = {
    search: currentSearchValue,
    statuses: filters.status,
    vendorIds: filters.vendorIds,
    eta: filters.eta,
    page: currentPage,
    itemsPerPage: currentItemsPerPage,
  };
  
  // Auto-reset page to 1 when non-page params change
  const shouldSkipRequest = usePageReset(setCurrentPage, currentPage, 'get:/api/v1/shipments');
  
  const currentIsFirstLoadComplete = testId && testData?.isFirstLoadComplete ? testData.isFirstLoadComplete : isFirstLoadComplete;
  const currentShipments = testId && testData?.shipmentData ? testData.shipmentData : shipmentData;
  const currentShipmentBoxIds = (currentShipments || []).reduce((acc, shipment) => {
    let boxIdCounter = 1;
    const shipmentKey = `${shipment.id}`;
    if (!acc[shipmentKey]) {
      acc[shipmentKey] = {};
    }
    shipment.products.forEach((product) => {
      const productKey = `${product.id}`;
      if (!acc[shipmentKey][productKey]) {
        acc[shipmentKey][productKey] = {};
      }
      product.boxes.forEach((box) => {
        const boxKey = `${box.id}`;
        acc[shipmentKey][productKey][boxKey] = boxIdCounter;
        boxIdCounter++;
      });
    });
    return acc;
  }, {});
  const isDeleteShipmentLoading = () => shipmentLoadingKeys.includes(ShipmentsLoadingKeys.deleteShipment);
  const isDeleteBoxLoading = () => shipmentLoadingKeys.includes(ShipmentsLoadingKeys.deleteBox);
  const isDeleteContainerLoading = () => shipmentLoadingKeys.includes(ShipmentsLoadingKeys.deleteContainer);
  const isShipmentsLoading = () => {
    if (testId && testData?.shipmentsLoading) {
      return testData?.shipmentsLoading
    }
    return shipmentLoadingKeys.includes(ShipmentsLoadingKeys.shipments);
  };
  const syncIsLoading = () => shipmentLoadingKeys.includes(ShipmentsLoadingKeys.sync);
  const allPrintsIsLoading = () => shipmentLoadingKeys.includes(ShipmentsLoadingKeys.printAll);
  const allContainerPrintsIsLoading = () => shipmentLoadingKeys.includes(ShipmentsLoadingKeys.printAllContainers);
  const receiveAllIsLoading = () => {
    if (receiveAllTarget?.type === 'boxes') {
      return shipmentLoadingKeys.includes(ShipmentsLoadingKeys.updateBox);
    }
    if (receiveAllTarget?.type === 'container') {
      return shipmentLoadingKeys.includes(ShipmentsLoadingKeys.updateContainerItem);
    }
    return false;
  };
  const submitReceiveAll = async () => {
    if (!receiveAllTarget) return;

    if (receiveAllTarget.type === 'container') {
      await dispatch(updateContainerItem({
        containerItems: receiveAllTarget.container.items.map((containerItem) => ({
          ...containerItem,
          receivedQuantity: containerItem.quantity,
        })),
        ...listParams,
        source: 'receive_all',
      }));
    } else {
      await dispatch(updateBox({
        boxes: receiveAllTarget.product.boxes.map((box) => ({
          ...box,
          receivedQuantity: box.quantity,
        })),
        ...listParams,
        source: 'receive_all',
      }));
    }

    setReceiveAllTarget(null);
  };

  useEffect(() => {
    if (testId) return
    const tag = pageTag?.replace("#", "");
    if (tag) {
      setExpandedShipments(prev => ({
        ...prev,
        [tag]: true
      }));
    }
    return () => {
      setEditedBoxes({})
    }
  }, [])
  useEffect(() => {
    if (!observeRef.current) {
      console.warn("observeRef is not available");
      return;
    }
    const observer = new IntersectionObserver(
      ([entry]) => {
        setAddShadow(!entry.isIntersecting);
      },
      {
        root: null,
        threshold: 0,
        rootMargin: "0px 0px -100% 0px",
      }
    );    
    observer.observe(observeRef.current);
    return () => {
      if (observeRef.current) {
        observer.unobserve(observeRef.current);
      }
    };
  }, []);
  useEffect(() => {
    axios
      .get('/api/v1/management/vendors-options')
      .then(({ data }) => {
        const uniqueOptions = Array.from(
          new Map((data || []).map((option) => [`${option.value}:${option.label}`, option])).values()
        );
        setVendorOptions(uniqueOptions);
      })
      .catch(() => {});
  }, []);
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest('.dropdown-action')) {
        setOpenedDropdownId(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    if (testId) return
    scrollToTop();
  }, [currentPage, currentItemsPerPage]);

  const fetchShipmentsData = async () => {
    dispatch(getAllShipments(listParams));
  }
  const undoShipmentIsLoading = () => shipmentLoadingKeys.includes(ShipmentsLoadingKeys.undoLastShipmentBatch);
  const submitUndoShipment = async () => {
    try {
      const result = await dispatch(undoLastShipmentBatch({}));
      unwrapResult(result);
      setUndoShipmentModalOpen(false);
      fetchShipmentsData();
      setShipmentHistoryRefreshToken((token) => token + 1);
    } catch {
      setUndoShipmentModalOpen(false);
    }
  };
  useEffect(() => {
    if (testId) return
    
    if (currentPage === 1 && shouldSkipRequest()) {
      const params = new URLSearchParams({
        ...listParams,
        statuses: filters.status.join(','),
        vendorIds: filters.vendorIds.join(','),
      });
      let url = `${ROUTES.SHIPPING}?${params}`;
      if (pageTag) {
        url = url + pageTag;
      };
      navigate(url);
      setSelectedBulkBoxes([]);
      return;
    }
    
    fetchShipmentsData();
    const params = new URLSearchParams({
      ...listParams,
      statuses: filters.status.join(','),
      vendorIds: filters.vendorIds.join(','),
    });
    let url = `${ROUTES.SHIPPING}?${params}`;
    if (pageTag) {
      url = url + pageTag;
    };
    navigate(url);
    setSelectedBulkBoxes([]);
  }, [
    currentSearchValue, 
    filters.status,
    filters.vendorIds,
    filters.eta,
    currentItemsPerPage,
    currentPage
  ]);

  useEffect(() => {
    if (testId) return
    if (shipments) {
      setShipmentData(shipments)
    }
  }, [shipments])

  const [selectedProducts, setSelectedProducts] = useState({});

  const getFilteredProducts = (shipment) => {
    const shipmentId = shipment?.id;
    if (!selectedProducts[shipmentId] || selectedProducts[shipmentId] === "all") {
      return shipment.products;
    }
    return shipment.products.filter((product) => product.sku === selectedProducts[shipmentId]);
  };

  useEffect(() => {
    const expandedIds = Object.entries(expandedShipments)
      .filter(([_, isExpanded]) => isExpanded)
      .map(([id]) => id);
    
    setSelectedBulkBoxes((prev) =>
      prev.filter((box) => expandedIds.includes(box.poId))
    );
  }, [expandedShipments]);

  const handleProductFilter = (productSKU, shipmentId) => {
    setSelectedProducts({
      ...selectedProducts,
      [shipmentId]: productSKU
    });
  };

  useEffect(() => {
    if (!isFirstLoadComplete) return;
    for (const shipment of shipments) {
      const selectedProduct = selectedProducts[shipment.id];
      if (selectedProduct === 'all') continue;

      const product = shipment.products.find(p => p.sku === selectedProduct);
      if (!product?.boxes?.length) {
        setSelectedProducts({
          ...selectedProducts,
          [shipment.id]: 'all'
        });
      }
    }
  }, [selectedProducts, shipments, isFirstLoadComplete])

  const availableFilters = {
    status: statuses,
    vendors: [...new Set(vendorOptions.map((vendor) => vendor.label))],
  };
  const selectedVendorNames = filters.vendorIds
    .map((vendorId) => vendorOptions.find((vendor) => String(vendor.value) === String(vendorId))?.label)
    .filter(Boolean);
  const shipmentCount = Number(pagination.rangeRows?.match(/of\s+(\d+)$/)?.[1] || currentShipments.length);

  const printIsLoading = shipmentLoadingKeys.includes(ShipmentsLoadingKeys.print) || shipmentLoadingKeys.includes(ShipmentsLoadingKeys.printContainer);
  const packingPlanIsLoading = shipmentLoadingKeys.includes(ShipmentsLoadingKeys.printPackingPlan);

  const handleFilterChange = (filterType, selectedOptions) => {
    setFilters(prevFilters => ({
      ...prevFilters,
      [filterType]: filterType === 'vendorIds'
        ? selectedOptions
          .map((label) => vendorOptions.find((vendor) => vendor.label === label)?.value)
          .filter(Boolean)
        : selectedOptions
    }));
  };

  const toggleShipmentExpansion = (shipmentId, event) => {
    // Prevent toggling if the click was on the sync button or its children
    if (event.target.closest('.sync-button')) {
      return;
    }
    setExpandedShipments(prev => ({
      ...prev,
      [shipmentId]: !prev[shipmentId]
    }));
  };

  const handleSubmitShipment = (poData, poId) => {
    dispatch(addShipmentElement({ poData, poId, ...listParams }));
    setIsModalOpen(false);
  };

  const handleSubmitContainer = async ({
    containerName,
    containerId,
    poId,
    productData
  }) => {
    if (containerId) {
      await dispatch(addItemsToContainer({
        containerId,
        poId,
        productData,
        ...listParams,
      })).unwrap();
    } else {
      await dispatch(addContainerToThePO({
        containerName,
        poId,
        productData,
        ...listParams,
      })).unwrap();
    }
    setIsContainerOpen(false);
    setExistingContainer(null);
  }

  const handlePrintContainer = async ({
    containerId
  }) => {
    const resultAction = await dispatch(printContainerData({ containerId }));
    setPrintingList(printingList.filter((item) => item !== containerId));
    const res = unwrapResult(resultAction);
    printJS({
      printable: res.url,
      type: 'pdf',
      multiple: true
    });
  }

  const handlePrintPackingPlan = async ({ containerId, printWindow }) => {
    const resultAction = await dispatch(printPackingPlan({ containerId }));
    setPrintingList(printingList.filter((item) => item !== containerId));
    if (printPackingPlan.fulfilled.match(resultAction)) {
      if (printWindow) {
        printWindow.opener = null;
        printWindow.location.href = resultAction.payload.url;
      } else {
        window.open(resultAction.payload.url, '_blank', 'noopener,noreferrer');
      }
    } else {
      printWindow?.close();
    }
  };

  const handlePrintContainers = async (shipment) => {
    const id = `${shipment.id}_${shipment.containers[0].id}`
    const shipmentContainers = (shipment.containers || []).map((container) => container.id);
    const resultAction = await dispatch(printAllContainers({ shipmentId: shipment.id, shipmentContainers }));
    setPrintingList(printingList.filter((item) => item !== id));
    const res = unwrapResult(resultAction);
    printJS({
      printable: res.url,
      type: "pdf",
      multiple: true,
    });
  }; 

  const handlePrint = async (data) => {
    const resultAction = await dispatch(printPOLabelData({ poData: data }));
    setPrintingList(printingList.filter((item) => item !== data.id));
    const res = unwrapResult(resultAction);
    printJS({
      printable: res.url,
      type: 'pdf',
      multiple: true
    });
  }

  const handlePrintLabels = async (shipment) => {
    const shipmentBoxes = (shipment.products || []).reduce((acc, product) => {
      const boxMap = product.boxes.reduce((boxAcc, box) => {
        boxAcc[`${box.id}`] = currentShipmentBoxIds[shipment.id][product.id][box.id].toString();
        return boxAcc;
      }, {});
      acc[`${product.id}`] = boxMap;
      return acc;
    }, {});
    const resultAction = await dispatch(printAllPOLabels({ id: shipment.id, shipmentBoxes }));
    setPrintingList(printingList.filter((item) => item !== shipment.id));
    const res = unwrapResult(resultAction);
    printJS({
      printable: res.url,
      type: "pdf",
      multiple: true,
    });
  };

  const pastDueDatesBlockIsVisible = (status) => {
    return !excludedStatusesForEmail.includes(status);
  }

  const handlePrintProductBoxes = async (shipmentId, productId, boxes) => {
    const boxesIds = {
      [`${productId}`]: (boxes || []).reduce((boxAcc, box) => {
        boxAcc[`${box.id}`] = currentShipmentBoxIds[shipmentId][productId][box.id];
        return boxAcc;
      }, {})
    };
    const resultAction = await dispatch(printAllProductLabels({ shipmentId, productId, boxesIds }));
    setPrintingList(printingList.filter((item) => item !== productId));
    const res = unwrapResult(resultAction);
    printJS({
      printable: res.url,
      type: 'pdf',
      multiple: true
    });
  };

  return (
    <>
      <div
        className="flex flex-col gap-4 px-6 pt-6 md:flex-row md:items-start md:justify-between"
      >
        <div>
          <div className="flex items-center gap-3">
            <h1 className="text-2xl font-semibold text-gray-900">Shipments Inbound</h1>
          </div>
          <p className="mt-1 text-sm text-gray-500">Track inbound POs, containers and boxes from vendor to warehouse</p>
        </div>
        {access === "edit" && (
          <div className="flex flex-row gap-2">
            <button
              type="button"
              title="Change history"
              aria-label="Change history"
              onClick={() => setShipmentHistoryOpen(true)}
              className="inline-flex h-8 w-8 items-center justify-center rounded-md border border-gray-200 bg-white text-gray-600 transition-colors hover:bg-gray-50 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 disabled:text-gray-300 disabled:cursor-not-allowed disabled:hover:bg-white"
            >
              <ClockIcon className="h-4 w-4" />
            </button>
            <button
              type="button"
              title="Undo"
              aria-label="Undo"
              onClick={() => setUndoShipmentModalOpen(true)}
              className="inline-flex h-8 w-8 items-center justify-center rounded-md border border-gray-200 bg-white text-gray-600 transition-colors hover:bg-gray-50 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 disabled:text-gray-300 disabled:cursor-not-allowed disabled:hover:bg-white"
            >
              <ArrowUturnLeftIcon className="h-4 w-4" />
            </button>
            <a
              href={ROUTES.PRINT_SETTINGS}
              title="Print settings"
              aria-label="Print settings"
              className="inline-flex h-8 w-8 items-center justify-center rounded-md border border-gray-200 bg-white text-gray-600 transition-colors hover:bg-gray-50 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 disabled:text-gray-300 disabled:cursor-not-allowed disabled:hover:bg-white"
            >
              <PrinterIcon className="h-4 w-4" />
            </a>
            <button
              type="button"
              title="Bulk edit"
              aria-label="Bulk edit"
              onClick={() => setOpenedBulkEditModal(true)}
              disabled={!arrayHasItems(selectedBulkBoxes)}
              className="inline-flex h-8 w-8 items-center justify-center rounded-md border border-gray-200 bg-white text-gray-600 transition-colors hover:bg-gray-50 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 disabled:text-gray-300 disabled:cursor-not-allowed disabled:hover:bg-white"
            >
              <PencilSquareIcon className="h-4 w-4" />
            </button>
            <button
              type="button"
              title="Create container"
              aria-label="Create container"
              onClick={() => {
                setExistingContainer(null);
                setIsContainerOpen(true);
              }}
              className="inline-flex h-8 w-8 items-center justify-center rounded-md border border-gray-200 bg-white text-gray-600 transition-colors hover:bg-gray-50 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 disabled:text-gray-300 disabled:cursor-not-allowed disabled:hover:bg-white"
            >
              <ArchiveBoxIcon className="h-4 w-4" />
            </button>
            <button
              type="button"
              onClick={() => setIsModalOpen(true)}
              className="inline-flex h-8 items-center gap-2 rounded-md border border-black bg-black px-3 text-sm font-medium text-white transition-colors hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
            >
              <PlusIcon className="h-4 w-4" />
              Create Shipment
            </button>
          </div>
        )}
      </div>
      <div ref={observeRef} style={{ height: 1 }} />
      <main className="w-full px-6" data-testid={testId}>
        <div className="pb-6">
          <div className="mt-6 flex flex-wrap items-center gap-3">
            <div className="relative w-full md:w-[380px]">
              <MagnifyingGlassIcon className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
              <input
                value={searchTerm}
                onChange={(event) => setSearchTerm(event.target.value)}
                placeholder="Search PO, vendor, tracking #..."
                className="h-9 w-full rounded-md border border-gray-200 bg-white pl-10 pr-3 text-sm shadow-sm outline-none focus:border-gray-400"
              />
            </div>
            <StatusFilter
              options={availableFilters.status}
              selectedOptions={filters.status}
              onChange={(selected) => handleFilterChange('status', selected)}
              placeholder="All Status"
              triggerClassName="h-9 rounded-md border border-gray-200 bg-white px-3 text-sm shadow-sm"
              portal
            />
            <StatusFilter
              options={availableFilters.vendors}
              selectedOptions={selectedVendorNames}
              onChange={(selected) => handleFilterChange('vendorIds', selected)}
              placeholder="All Vendors"
              triggerClassName="h-9 rounded-md border border-gray-200 bg-white px-3 text-sm shadow-sm"
              portal
            />
            <select
              value={filters.eta}
              onChange={(event) => handleFilterChange('eta', event.target.value)}
              className="h-9 rounded-md border border-gray-200 bg-white px-3 text-sm shadow-sm"
              aria-label="ETA filter"
            >
              <option value="">Any ETA</option>
              <option value="past_due">Past due</option>
              <option value="next_7">Next 7 days</option>
              <option value="next_30">Next 30 days</option>
              <option value="no_eta">No ETA</option>
            </select>
            <span className="ml-auto text-sm text-gray-500">{shipmentCount} shipments</span>
          </div>
          {/* Shipments Table */}
          <div className="relative mt-4 overflow-hidden rounded-lg border border-gray-200" ref={wrapperTableRef}>
            {isShipmentsLoading() && currentIsFirstLoadComplete && (
              <OverlayGrayBackground testId={testId ? `overlay-loading-${testId}` : undefined} />
            )}
            <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-100">
                <tr>
                  <th scope="col" className="px-4 py-2.5 text-left text-xs font-medium uppercase tracking-wide text-gray-900">Shipment</th>
                  <th scope="col" className="px-4 py-2.5 text-left text-xs font-medium uppercase tracking-wide text-gray-900">Vendor</th>
                  <th scope="col" className="px-4 py-2.5 text-left text-xs font-medium uppercase tracking-wide text-gray-900">Status</th>
                  <th scope="col" className="px-4 py-2.5 text-left text-xs font-medium uppercase tracking-wide text-gray-900">Shipped</th>
                  <th scope="col" className="px-4 py-2.5 text-left text-xs font-medium uppercase tracking-wide text-gray-900">Est. Delivery</th>
                  <th scope="col" className="px-4 py-2.5 text-left text-xs font-medium uppercase tracking-wide text-gray-900">Received</th>
                  <th scope="col" className="px-4 py-2.5 text-right text-xs font-medium uppercase tracking-wide text-gray-900">Actions</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {currentShipments.length > 0 ? (
                  currentShipments.map((shipment, index) => {
                    return (
                      <React.Fragment key={shipment.id}>
                        <tr
                          className="bg-white hover:bg-gray-50 cursor-pointer"
                          id={shipment.id}
                          data-testid={testId ? `po-${index}-${testId}` : undefined}
                          onClick={(event) => (anyShipmentProductHasBoxes(shipment.products) || arrayHasItems(shipment.containers)) ? toggleShipmentExpansion(shipment.id, event) : null}
                        >
                          <td className="px-4 py-3 whitespace-nowrap">
                            <div className="flex items-center">
                              {(anyShipmentProductHasBoxes(shipment.products) || arrayHasItems(shipment.containers)) ? (
                                <button
                                  type="button"
                                  aria-label="Toggle shipment details"
                                  className="mr-2 flex-shrink-0"
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    toggleShipmentExpansion(shipment.id, event);
                                  }}
                                >
                                  {expandedShipments[shipment.id] ? (
                                    <ChevronUpIcon className="h-4 w-4 text-gray-500" />
                                  ) : (
                                    <ChevronDownIcon className="h-4 w-4 text-gray-500" />
                                  )}
                                </button>
                              ) : null}
                              <div>
                                <div className="flex flex-row items-center gap-2 font-medium text-gray-900">
                                  <span className="block">
                                    {shipment.poNumber}
                                  </span>
                                  {(shipment?.messageSoonData || shipment?.messageTodayData) && (
                                    <div>
                                      <InformationCircleIcon 
                                        className={`h-4 w-4 ${(shipment?.messageSoonData?.error || shipment?.messageTodayData?.error) ? 'text-red-600 hover:text-red-700' : 'text-blue-600 hover:text-blue-700'}`}
                                        data-tip={true}
                                        data-for={`tooltip-email_${shipment.id}_${index}`}
                                      />
                                      <ReactTooltip
                                        id={`tooltip-email_${shipment.id}_${index}`}
                                        html={true}
                                        place="right"
                                        effect='solid'
                                      >
                                        {`
                                          <div>
                                            ${shipment?.messageSoonData ? (`<span class="block">Vendor reminder ( 7 days ): ${shipment?.messageSoonData?.error ? `Error: ${shipment?.messageSoonData?.error}` : shipment?.messageSoonData?.sendDate}</span>`) : ""}
                                            ${shipment?.messageTodayData ? (`<span class="block">Vendor reminder ( 0 days ): ${shipment?.messageTodayData?.error ? `Error: ${shipment?.messageTodayData?.error}` : shipment?.messageTodayData?.sendDate}</span>`) : ""}
                                          </div>
                                        `}
                                      </ReactTooltip>
                                    </div>
                                  )}
                                </div>
                                <div
                                  className="text-xs text-gray-500"
                                  title={shipment.shipmentDate}
                                >
                                  {shipment.containerCount > 0 && `${shipment.containerCount} ${shipment.containerCount === 1 ? 'container' : 'containers'} · `}
                                  {shipment.boxCount || 0} {shipment.boxCount === 1 ? 'box' : 'boxes'}
                                </div>
                              </div>
                            </div>
                          </td>
                          <td className="max-w-[260px] truncate px-4 py-3 text-gray-600" title={shipment.vendor || ''}>
                            {shipment.vendor || '—'}
                          </td>
                          <td className="px-4 py-3 whitespace-nowrap">
                            <span className={`inline-flex items-center rounded-md px-2 py-0.5 text-xs font-medium ${getStatusColor(shipment.status)}`}>
                              {enumStatuses[shipment.status]}
                            </span>
                          </td>
                          <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">
                            {shipment.shippedDate || '—'}
                          </td>
                          <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">
                            <div className="flex flex-col gap-1"> 
                              <div className="flex items-center gap-1">
                                {shipment.estimatedDeliveryDate || null}
                              </div>
                              {shipment?.pastDueDaysData && pastDueDatesBlockIsVisible(shipment.status) && (
                                <div className={`text-xs ${
                                  shipment.pastDueDaysData.text?.includes('ago')
                                    ? 'font-medium text-red-600'
                                    : 'text-gray-500'
                                }`}>
                                  {shipment.pastDueDaysData.text?.replace(/[()]/g, '').replace('ago', 'past due') || null}
                                </div>
                              )}
                            </div>
                          </td>
                          <td className="px-4 py-3 whitespace-nowrap">
                            {(() => {
                              return (
                                <div className="flex flex-col gap-1">
                                  {shipment?.rangeActualDate && (
                                    <div className="text-xs text-green-700">
                                      {shipment.rangeActualDate}
                                    </div>
                                  )}
                                  <ReceivedQtyBarGraph products={shipment.products} containers={shipment.containers}/>
                                </div>
                              );
                            })()}
                          </td>
                          <td className="px-4 py-3">
                              <div className="flex flex-row items-center justify-end gap-2">
                                {access === "edit" && (
                                  <button
                                    type="button"
                                    className="sync-button inline-flex h-7 w-7 items-center justify-center rounded-md border border-gray-200 bg-white text-gray-600 shadow-sm hover:bg-gray-100"
                                    title="Sync with ShipHero"
                                    aria-label="Sync with ShipHero"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setSyncConfirmModalOpened(true);
                                      setSyncShipmentId(shipment.id);
                                    }}
                                    disabled={syncingShipments.includes(shipment.id)}
                                  >
                                    <ArrowPathIcon className={`h-4 w-4 ${syncingShipments.includes(shipment.id) ? 'animate-spin' : ''}`} />
                                  </button>
                                )}
                                <button
                                  type="button"
                                  className="inline-flex h-7 w-7 items-center justify-center rounded-md border border-gray-200 bg-white text-gray-600 shadow-sm hover:bg-gray-100 disabled:opacity-40"
                                  title="Print labels"
                                  aria-label="Print labels"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setPrintingList([...printingList, shipment.id]);
                                    handlePrintLabels(shipment);
                                  }}
                                  disabled={!anyShipmentProductHasBoxes(shipment.products) || (allPrintsIsLoading() && printingList.includes(shipment.id))}
                                >
                                  {allPrintsIsLoading() && printingList.includes(shipment.id)
                                    ? <ArrowPathIcon className="h-4 w-4 animate-spin" />
                                    : <PrinterIcon className="h-4 w-4" />}
                                </button>
                                <button
                                  type="button"
                                  className="rounded p-1 text-gray-500 hover:text-red-600 hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-red-300 disabled:opacity-50"
                                  title="Delete shipment"
                                  aria-label="Delete shipment"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    if (!shipmentToDelete) {
                                      setShipmentToDelete(shipment.id);
                                      setDeleteShipmentModalOpened(true);
                                    }
                                  }}
                                >
                                  {(isDeleteShipmentLoading() && shipmentToDelete === shipment.id) ? (
                                    <ArrowPathIcon className="animate-spin h-4 w-4" />
                                  ) : (
                                    <TrashIcon className="h-4 w-4" aria-hidden="true" />
                                  )}
                                </button>
                                {(shipment?.possibleToSendEmail7Days || shipment?.possibleToSendEmailToday || shipment?.possibleToSendOldEmail) && (
                                  <EmailsDropdownMenu
                                    shipment={shipment}
                                    isOpen={openedDropdownId === shipment.id}
                                    onToggle={() => {
                                      setOpenedDropdownId((prev) => (prev === shipment.id ? null : shipment.id));
                                    }}
                                    setSyncEmail={setSyncEmail}
                                    syncEmail={syncEmail}
                                    emailIsLoading={emailIsLoading}
                                    possibleToSendEmail7Days={shipment.possibleToSendEmail7Days}
                                    possibleToSendEmailToday={shipment.possibleToSendEmailToday}
                                    possibleToSendOldEmail={shipment.possibleToSendOldEmail}
                                  />
                                )}
                                {/* <div>
                                  <EllipsisVerticalIcon className='h-6 w-6 text-primary hover:text-gray-900'
                                    data-tip={true}
                                    data-for={`tooltip-reminder_${shipment.id}_${index}`}
                                  />
                                  <ReactTooltip
                                    id={`tooltip-reminder_${shipment.id}_${index}`}
                                    html={true}
                                    effect='solid'
                                    place="left"
                                    className="!max-w-[335px] !text-sm !break-words"
                                  >
                                    {`
                                      <div class="flex flex-col">
                                        <span class="block">Reminder send email ( 7 days ): ${shipment?.reminderBetweenSevenAndZeroDays || null}</span>
                                        <span class="block">Reminder send email ( 0 days ): ${shipment?.reminderZeroDays || null}</span>
                                      </div>
                                    `}
                                  </ReactTooltip>
                                </div> */}
                              </div>
                            </td>
                        </tr>
                        {expandedShipments[shipment.id] && (anyShipmentProductHasBoxes(shipment.products) || arrayHasItems(shipment.containers)) && (
                          <tr className="bg-gray-50">
                            <td colSpan="7" className="pl-14 py-3">
                              {arrayHasItems(shipment.containers) && (
                                <>
                                  <div className='flex flex-row gap-2 items-center mb-2 justify-between'>
                                    <div className='flex flex-row gap-2 items-center'>
                                      <h4 className="text-sm font-medium">
                                        Containers
                                        <span className="ml-2 rounded-full bg-gray-100 px-2 py-0.5 text-xs text-gray-500">{shipment.containers.length}</span>
                                      </h4>
                                      <button
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setPrintingList([...printingList, `${shipment.id}_${shipment.containers[0].id}`]);
                                          handlePrintContainers(shipment);
                                        }}
                                        className="inline-flex items-center min-w-14 justify-center px-3 py-1.5 border border-transparent text-xs font-medium rounded text-gray-700 bg-gray-200 hover:bg-blue-500 hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200 disabled:bg-gray-200 disabled:text-gray-400 disabled:cursor-not-allowed"
                                      >
                                        {allContainerPrintsIsLoading() && printingList.includes(`${shipment.id}_${shipment.containers[0].id}`) ? <ArrowPathIcon className="animate-spin h-4 w-4" /> : "Print"}
                                      </button>
                                    </div>
                                  </div>
                                  <div className="mb-4 flex gap-4 flex-col">
                                    {shipment.containers.map((container) => {
                                      const receivedDate = editedContainers[container.id]?.actualDate !== undefined
                                        ? editedContainers[container.id].actualDate
                                        : container.actualDate || "";
                                      const dateShipped = editedContainers[container.id]?.dateShipped !== undefined
                                        ? editedContainers[container.id]?.dateShipped
                                        : container.dateShipped
                                        ? container.dateShipped
                                        : "";
                                      return (
                                        <div key={container.id} className="relative w-full overflow-hidden rounded-md border border-gray-200 bg-white p-4">
                                          <div className='border-b pb-2 mb-4 flex flex-row gap-2 justify-between items-center'>
                                            <h2 className="font-semibold text-lg">{container.name || "Container"}</h2>
                                            <ReceivedQtyBarGraph containers={[container]} />
                                            <div className='flex gap-3'>
                                              <button
                                                type="button"
                                                title="Print container labels"
                                                aria-label="Print container labels"
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  setPrintingList([...printingList, container.id]);
                                                  handlePrintContainer({
                                                    containerId: container.id,
                                                  });
                                                }}
                                                className="rounded p-1 text-gray-500 hover:text-gray-900 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-400 disabled:text-gray-300 disabled:cursor-not-allowed"
                                              >
                                                {printIsLoading && printingList.includes(container.id) ? <ArrowPathIcon className="animate-spin h-4 w-4" /> : <PrinterIcon className="h-4 w-4" aria-hidden="true" />}
                                              </button>
                                              <button
                                                type="button"
                                                title="Packing plan"
                                                aria-label="Packing plan"
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  const printWindow = window.open('about:blank', '_blank');
                                                  setPrintingList([...printingList, container.id]);
                                                  handlePrintPackingPlan({
                                                    containerId: container.id,
                                                    printWindow,
                                                  });
                                                }}
                                                className="rounded p-1 text-gray-500 hover:text-gray-900 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-400 disabled:text-gray-300 disabled:cursor-not-allowed"
                                              >
                                                {packingPlanIsLoading && printingList.includes(container.id) ? <ArrowPathIcon className="animate-spin h-4 w-4" /> : <DocumentTextIcon className="h-4 w-4" aria-hidden="true" />}
                                              </button>
                                              {access === "edit" && (
                                                <button
                                                  type="button"
                                                  title="Add items"
                                                  aria-label="Add items"
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    setExistingContainer({ id: container.id, name: container.name || "Container" });
                                                    setIsContainerOpen(true);
                                                  }}
                                                  className="rounded p-1 text-gray-500 hover:text-gray-900 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-400 disabled:text-gray-300 disabled:cursor-not-allowed"
                                                >
                                                  {shipmentLoadingKeys.includes(ShipmentsLoadingKeys.addItemsToContainer)
                                                    ? <ArrowPathIcon className="animate-spin h-4 w-4" />
                                                    : <PlusIcon className="h-4 w-4" aria-hidden="true" />}
                                                </button>
                                              )}
                                              {access === "edit" && (
                                                <button
                                                  type="button"
                                                  title="Delete container"
                                                  aria-label="Delete container"
                                                  className="rounded p-1 text-gray-500 hover:text-red-600 hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-red-300 disabled:opacity-50"
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    setContainerToDelete(container.id);
                                                    setDeleteContainerModalOpened(true);
                                                  }}
                                                >
                                                  {(isDeleteContainerLoading() && containerToDelete === container.id) ? (
                                                    <ArrowPathIcon className="animate-spin h-4 w-4" />
                                                  ) : (
                                                    <TrashIcon className="h-4 w-4" aria-hidden="true" />
                                                  )}
                                                </button>
                                              )}
                                            </div>
                                          </div>
                                          <div className="flex flex-row gap-8 mb-4 items-end">
                                            <div className="flex flex-col gap-2">
                                              <span className="font-bold whitespace-nowrap">Shipping Method</span>
                                              <select
                                                  value={
                                                    editedContainers[container.id]?.shippingMethod !== undefined
                                                      ? editedContainers[container.id]?.shippingMethod
                                                      : container.shippingMethod ? container.shippingMethod
                                                      : ""
                                                  }
                                                  onChange={(e) => {
                                                    if (access === "edit") {
                                                      setEditedContainers({
                                                        ...editedContainers,
                                                        [container.id]: {
                                                          ...(editedContainers[container.id] || container),
                                                          shippingMethod: e.target.value
                                                        }
                                                      })
                                                    }
                                                }}
                                                disabled={access !== "edit"}
                                                className={`block h-8 w-64 rounded-md border border-gray-200 bg-white px-2 text-sm shadow-sm focus:border-gray-400 focus:outline-none disabled:bg-gray-200 ${getShippingMethodColor(container.shippingMethod)}`}
                                              >
                                                <option value={null} className="bg-gray-100 text-gray-800"></option>
                                                <option value={SEA} className="bg-blue-100 text-blue-800">{enumBoxTypes[SEA]}</option>
                                                <option value={AIR} className="bg-indigo-100 text-indigo-800">{enumBoxTypes[AIR]}</option>
                                              </select>
                                            </div>
                                            <div className="flex flex-col gap-2">
                                              <span className="font-bold whitespace-nowrap">Tracking Number</span>
                                              <div className="flex items-center gap-2">
                                                <input
                                                  type="text"
                                                  value={
                                                    editedContainers[container.id]?.trackingNumber !== undefined
                                                      ? editedContainers[container.id]?.trackingNumber
                                                      : container.trackingNumber
                                                        ? container.trackingNumber
                                                        : ""
                                                  }
                                                  disabled={access !== "edit"}
                                                  onChange={(e) => {
                                                    if (access === "edit") {
                                                      setEditedContainers({
                                                        ...editedContainers,
                                                        [container.id]: {
                                                          ...(editedContainers[container.id] || container),
                                                          trackingNumber: e.target.value
                                                        }
                                                      })
                                                    }
                                                  }}
                                                  className="h-8 w-64 rounded-md border border-gray-200 px-2 text-sm shadow-sm focus:border-gray-400 focus:outline-none disabled:bg-gray-200"
                                                />
                                                {container.trackingNumber && (
                                                  <a href={`https://www.ups.com/track?track=yes&trackNums=${container.trackingNumber}&loc=en_US&requester=ST/trackdetails`} target="_blank">
                                                    <LinkIcon className="h-4 w-4 cursor-pointer fill-blue-500 hover:fill-blue-900" aria-hidden="true" />
                                                  </a>
                                                )}
                                              </div>
                                            </div>
                                            <div className="flex flex-col gap-2">
                                              <span className="font-bold whitespace-nowrap">Date Shipped</span>
                                              <div className="relative w-64">
                                                <BoxDate
                                                  key={dateShipped}
                                                  box={container}
                                                  access={access}
                                                  date={dateShipped}
                                                  formattedDate={container.formattedShippedDate}
                                                  setEditedBoxes={setEditedContainers}
                                                  editedBoxes={editedContainers}
                                                  keyDate={"dateShipped"}
                                                  additionalWrapperClassname={"!w-56"}
                                                  additionalHoverClassname={"!w-32"}
                                                />
                                                {dateShipped && (
                                                  <DocumentDuplicateIcon 
                                                    className="h-5 w-5 cursor-pointer absolute right-0 -translate-y-1/2 top-1/2 text-gray-500 hover:text-gray-400" 
                                                    onClick={() => {
                                                      const formatted = formatDateForInput(dateShipped);
                                                      if (formatted) {
                                                        navigator.clipboard.writeText(formatted);
                                                      }
                                                    }}
                                                  />
                                                )}
                                              </div>
                                            </div>
                                            <div className="flex flex-col gap-2">
                                              <span className="font-bold whitespace-nowrap">Est. Receive Date</span>
                                              <span className="py-1 px-2">
                                                {getEstimatedReceiveDateLabel({
                                                  explicitDate: container.estimatedReceiveDate,
                                                  edited: editedContainers[container.id],
                                                  shippingMethod: container.shippingMethod,
                                                  dateShipped: container.dateShipped,
                                                  resolvedDate: container.resolvedEstimatedReceiveDate,
                                                  poEstimatedDeliveryDate: shipment.estimatedDeliveryDate,
                                                })}
                                              </span>
                                            </div>
                                            <div className="flex flex-col gap-2">
                                              <span className="font-bold whitespace-nowrap">Received Date</span>
                                              <div className="relative w-64">
                                                <BoxDate
                                                  key={receivedDate}
                                                  box={container}
                                                  access={access}
                                                  date={receivedDate}
                                                  formattedDate={container.formattedActualDate}
                                                  setEditedBoxes={setEditedContainers}
                                                  editedBoxes={editedContainers}
                                                  keyDate={"actualDate"}
                                                  additionalWrapperClassname={"!w-56"}
                                                  additionalHoverClassname={"!w-32"}
                                                />
                                                {receivedDate && (
                                                  <DocumentDuplicateIcon 
                                                    className="h-5 w-5 cursor-pointer absolute right-0 -translate-y-1/2 top-1/2 text-gray-500 hover:text-gray-400" 
                                                    onClick={() => {
                                                      const formatted = formatDateForInput(receivedDate);
                                                      if (formatted) {
                                                        navigator.clipboard.writeText(formatted);
                                                      }
                                                    }}
                                                  />
                                                )}
                                              </div>
                                            </div>
                                            <div className="flex items-center gap-2">
                                              {editedContainers[container.id] && access === "edit" && (
                                                <div className="flex flex-row gap-2">
                                                  <button
                                                    onClick={async () => {
                                                      if (testId) {
                                                        console.log("Submit box changes!")
                                                        return
                                                      }
                                                      try {
                                                        const editedContainersData = { ...editedContainers[container.id], shippingMethod: editedContainers[container.id]?.shippingMethod || null }
                                                        await dispatch(
                                                          updateContainer({
                                                            containers: [editedContainersData],
                                                            ...listParams,
                                                          })
                                                        ).unwrap();
                                                        const filteredObj = filterKeyFromObject(editedContainers, container.id);
                                                        setEditedContainers({
                                                          ...filteredObj,
                                                        });
                                                      } catch (error) {
                                                        console.error("Error updating box:", error);
                                                      }
                                                    }}
                                                    className="inline-flex items-center px-3 py-1.5 border border-transparent rounded shadow-sm text-white bg-green-500 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                                  >
                                                    <CheckIcon className="h-4 w-4" aria-hidden="true" />
                                                  </button>
                                                  <button
                                                    onClick={() => {
                                                      if (testId) {
                                                          console.log("Cancel box changes!")
                                                        return
                                                      }
                                                      const filteredObj = filterKeyFromObject(editedContainers, container.id)
                                                      setEditedContainers({
                                                        ...filteredObj,
                                                      })
                                                    }}
                                                    className="inline-flex items-center px-3 py-1.5 border border-transparent rounded shadow-sm text-white bg-red-500 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                                  >
                                                    <XMarkIcon className="h-4 w-4" aria-hidden="true" />
                                                  </button>
                                                </div>
                                              )}
                                            </div>
                                          </div>
                                          <table className="min-w-full divide-y divide-gray-200">
                                            <thead className="bg-transparent">
                                              <tr className="border-b text-left text-gray-600">
                                                <th scope="col" className="px-3 py-2 text-left text-[11px] uppercase tracking-wide text-gray-500">SKU</th>
                                                <th scope="col" className="px-3 py-2 text-left text-[11px] uppercase tracking-wide text-gray-500">Shipping Method</th>
                                                <th scope="col" className="px-3 py-2 text-left text-[11px] uppercase tracking-wide text-gray-500">Tracking Number</th>
                                                <th scope="col" className="px-3 py-2 text-left text-[11px] uppercase tracking-wide text-gray-500">Date Shipped</th>
                                                <th scope="col" className="px-3 py-2 text-left text-[11px] uppercase tracking-wide text-gray-500">Est. Receive Date</th>
                                                <th scope="col" className="relative px-3 py-2 text-left text-[11px] uppercase tracking-wide text-gray-500">Received Date</th>
                                                <th scope="col" className="px-3 py-2 text-left text-[11px] uppercase tracking-wide text-gray-500">Units</th>
                                                <th scope="col" className="px-3 py-2 text-left text-[11px] uppercase tracking-wide text-gray-500">Received / Shipped / Ordered Qty</th>
                                                {access === "edit" && (
                                                  <th scope="col" className="px-3 py-2 text-left text-[11px] uppercase tracking-wide text-gray-500">
                                                    <button
                                                      className="ml-2 inline-flex h-7 items-center rounded-md border border-gray-200 bg-white px-2 text-xs font-medium hover:bg-gray-900 hover:text-white"
                                                      onClick={() => {
                                                        if (arrayHasItems(container.items)) {
                                                          setReceiveAllTarget({ type: 'container', container });
                                                        }
                                                      }}
                                                    >
                                                      Receive All
                                                    </button>
                                                  </th>
                                                )}
                                              </tr>
                                            </thead>
                                            <tbody className="bg-white divide-y divide-gray-200">
                                              {(container.items || []).map((item, idx) => {
                                                const shipped = editedContainers[`${container.id}_${item.id}`]?.shippedQuantity !== undefined ? editedContainers[`${container.id}_${item.id}`]?.shippedQuantity : (item.shippedQuantity || 0);
                                                const received = editedContainers[`${container.id}_${item.id}`]?.receivedQuantity !== undefined ? editedContainers[`${container.id}_${item.id}`]?.receivedQuantity : (item.receivedQuantity || 0);
                                                const shippedIsManual = editedContainers[`${container.id}_${item.id}`]?.shippedQuantityIsManual !== undefined ? editedContainers[`${container.id}_${item.id}`]?.shippedQuantityIsManual : (item.shippedQuantityIsManual || false);
                                                return (
                                                  <tr key={idx} className="border-b last:border-b-0">
                                                    <td className="px-3 py-2 text-[13px]">
                                                      {item.sku}
                                                      {item.poNumber && item.poNumber !== shipment.poNumber && (
                                                        <span className="ml-2 rounded bg-blue-50 px-1.5 py-0.5 text-[10px] font-medium text-blue-700">
                                                          {item.poNumber}
                                                        </span>
                                                      )}
                                                    </td>
                                                    <td className="px-3 py-2 text-[13px]">{enumBoxTypes[container.shippingMethod] || "N/A"}</td>
                                                    <td className="px-3 py-2 text-[13px]">{container.trackingNumber || "N/A"}</td>
                                                    <td className="px-3 py-2 text-[13px]">{container.formattedShippedDate || "N/A"}</td>
                                                    <td className="px-3 py-2 text-[13px]">
                                                      {getEstimatedReceiveDateLabel({
                                                        explicitDate: container.estimatedReceiveDate,
                                                        shippingMethod: container.shippingMethod,
                                                        dateShipped: container.dateShipped,
                                                        resolvedDate: container.resolvedEstimatedReceiveDate,
                                                        poEstimatedDeliveryDate: shipment.estimatedDeliveryDate,
                                                      })}
                                                    </td>
                                                    <td className="px-3 py-2 text-[13px]">{container.formattedActualDate || "N/A"}</td>
                                                    <td className="px-3 py-2 text-[13px]">{item.units}</td>
                                                    <td className="px-3 py-2 text-[13px]">
                                                      <div className="flex items-center space-x-2">
                                                        <input
                                                          type="text"
                                                          value={received}
                                                          onChange={(e) => {
                                                            if (access === "edit") {
                                                              let newValue = e.target.value;
                                                              if (/^\d*$/.test(newValue)) {
                                                                if (newValue.startsWith('0') && newValue.length > 1) {
                                                                    newValue = newValue.replace(/^0+/, '');
                                                                }
                                                                setEditedContainers({
                                                                  ...editedContainers,
                                                                  [`${container.id}_${item.id}`]: {
                                                                    ...(editedContainers[`${container.id}_${item.id}`] || item),
                                                                    receivedQuantity: Number(newValue || 0),
                                                                  },
                                                                });
                                                              }
                                                            }
                                                          }}
                                                          disabled={access !== "edit"}
                                                          className="w-14 disabled:bg-gray-200 py-0.5 px-2 shadow-sm border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                                        />
                                                        <span>/</span>
                                                        <input
                                                          type="text"
                                                          value={shipped}
                                                          onChange={(e) => {
                                                            if (access === "edit") {
                                                              let newValue = e.target.value;
                                                              if (/^\d*$/.test(newValue)) {
                                                                if (newValue.startsWith('0') && newValue.length > 1) {
                                                                    newValue = newValue.replace(/^0+/, '');
                                                                }
                                                                setEditedContainers({
                                                                  ...editedContainers,
                                                                  [`${container.id}_${item.id}`]: {
                                                                    ...(editedContainers[`${container.id}_${item.id}`] || item),
                                                                    shippedQuantity: Number(newValue || 0),
                                                                    shippedQuantityIsManual: true
                                                                  }
                                                                });
                                                              }
                                                            }
                                                          }}
                                                          disabled={access !== "edit"}
                                                          className="w-14 disabled:bg-gray-200 py-0.5 px-2 shadow-sm border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                                        />
                                                        <span>/</span>
                                                        <span>{item.quantity}</span>
                                                        <div className="flex items-center">
                                                          <input
                                                            type="checkbox"
                                                            id={`full-quantity-${container.id}_${item.id}`}
                                                            checked={Number(editedContainers[`${container.id}_${item.id}`]?.receivedQuantity || item.receivedQuantity) >= item.quantity}
                                                            onChange={(e) => {
                                                              if (access === "edit") {
                                                                setEditedContainers({
                                                                  ...editedContainers,
                                                                  [`${container.id}_${item.id}`]: {
                                                                    ...(editedContainers[`${container.id}_${item.id}`] || item),
                                                                    receivedQuantity: item.quantity,
                                                                  }
                                                                })
                                                              }
                                                            }}
                                                            disabled={access !== "edit"}
                                                            className="h-4 disabled:bg-gray-200 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                                                          />
                                                          <label htmlFor={`full-quantity-${container.id}_${item.id}`} className="ml-2 text-sm text-gray-600">
                                                            Full Qty
                                                          </label>
                                                        </div>
                                                      </div>
                                                    </td>
                                                    {access === "edit" && (
                                                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 w-[155px]">
                                                        <div className="flex items-center gap-2">
                                                          {editedContainers[`${container.id}_${item.id}`] && (
                                                            <div className="flex flex-row gap-2">
                                                              <button
                                                                onClick={async () => {
                                                                  if (testId) {
                                                                    console.log("Submit box changes!")
                                                                    return
                                                                  }
                                                                  try {
                                                                    const editedContainerData = { ...editedContainers[`${container.id}_${item.id}`] }
                                                                    await dispatch(
                                                                      updateContainerItem({
                                                                        containerItems: [editedContainerData],
                                                                        ...listParams,
                                                                      })
                                                                    ).unwrap();
                                                                    const filteredObj = filterKeyFromObject(editedContainers, `${container.id}_${item.id}`);
                                                                    setEditedContainers({
                                                                      ...filteredObj,
                                                                    });
                                                                  } catch (error) {
                                                                    console.error("Error updating box:", error);
                                                                  }
                                                                }}
                                                                className="inline-flex items-center px-3 py-1 border border-transparent rounded shadow-sm text-white bg-green-500 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                                              >
                                                                <CheckIcon className="h-4 w-4" aria-hidden="true" />
                                                              </button>
                                                              <button
                                                                onClick={() => {
                                                                  if (testId) {
                                                                    console.log("Cancel box changes!")
                                                                    return
                                                                  }
                                                                  const filteredObj = filterKeyFromObject(editedContainers, `${container.id}_${item.id}`)
                                                                  setEditedContainers({
                                                                    ...filteredObj,
                                                                  })
                                                                }}
                                                                className="inline-flex items-center px-3 py-1 border border-transparent rounded shadow-sm text-white bg-red-500 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                                              >
                                                                <XMarkIcon className="h-4 w-4" aria-hidden="true" />
                                                              </button>
                                                            </div>
                                                          )}
                                                        </div>
                                                      </td>
                                                    )}
                                                  </tr>
                                                )
                                              })}
                                              <tr className="font-semibold border-t">
                                                <td className="px-3 py-2 text-[13px]" colSpan={6}>Total</td>
                                                <td className="px-3 py-2 text-[13px]">{(container.items || []).reduce((acc, item) => acc + item?.units, 0)}</td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      )
                                    })}
                                  </div>
                                </>
                              )}
                              {arrayHasItems(shipment.containers) && anyShipmentProductHasBoxes(shipment.products) && (
                                <h4 className="mb-2 text-sm font-medium">
                                  Products
                                  <span className="ml-2 rounded-full bg-gray-100 px-2 py-0.5 text-xs text-gray-500">{shipment.products.length}</span>
                                </h4>
                              )}
                              {anyShipmentProductHasBoxes(shipment.products) && (
                                <>
                                  <div className="mb-4 flex gap-4 items-center">
                                    <select
                                      id="productFilter"
                                      className="h-8 w-72 rounded-md border border-gray-200 px-3 text-sm focus:border-gray-400 focus:outline-none"
                                      value={selectedProducts[shipment.id]}
                                      data-testid={testId ? `select-product-${shipment.id}-${testId}` : undefined}
                                      onChange={(e) => handleProductFilter(e.target.value, shipment.id)}
                                    >
                                      <option value="all">All Products</option>
                                      {(shipment.products || []).filter((product) => arrayHasItems(product.boxes || [])).map((product, index) => (
                                        <option
                                          key={product.sku}
                                          value={product.sku}
                                          data-testid={testId ? `option-product-${product.id}-${index}-${testId}` : undefined}
                                        >
                                          {product.name} ({product.sku})
                                        </option>
                                      ))}
                                    </select>
                                    {access === "edit" && (
                                      <input
                                        type="checkbox"
                                        onClick={(e) => e.stopPropagation()}
                                        checked={
                                          arrayHasItems(shipment.products) &&
                                          shipment.products
                                            .filter((product) => arrayHasItems(product.boxes))
                                            .every((product) =>
                                              product.boxes.every((box) =>
                                                selectedBulkBoxes.some((selected) => selected.id === box.id)
                                              )
                                            )
                                        }
                                        onChange={(e) => {
                                          e.stopPropagation();
                                          const allBoxesInShipment = shipment.products
                                            .filter((product) => arrayHasItems(product.boxes))
                                            .flatMap((product) => product.boxes);
                                          const allSelected = allBoxesInShipment.every((box) =>
                                            selectedBulkBoxes.some((selected) => selected.id === box.id)
                                          );
                                          if (allSelected) {
                                            setSelectedBulkBoxes((prev) =>
                                              prev.filter(
                                                (selected) =>
                                                  !allBoxesInShipment.some((box) => box.id === selected.id)
                                              )
                                            );
                                          } else {
                                            const newBoxes = allBoxesInShipment.filter(
                                              (box) =>
                                                !selectedBulkBoxes.some((selected) => selected.id === box.id)
                                            );
                                            setSelectedBulkBoxes((prev) => [...prev, ...newBoxes]);
                                          }
                                        }}
                                        disabled={
                                          !arrayHasItems(shipment.products) ||
                                          shipment.products.every((p) => !arrayHasItems(p.boxes))
                                        }
                                        className="w-5 h-5"
                                      />
                                    )}
                                  </div>
                                  {getFilteredProducts(shipment).map((product, index) => {
                                    if (!arrayHasItems(product.boxes || [])) return null;
                                    return (
                                      <div key={`${product.sku}_${index}`} className="mb-6">
                                        <div className="flex items-end justify-between mb-2">
                                          <div className="max-w-96 relative">
                                            <h4 className="max-w-96 text-sm font-medium">{product.name} ({product.sku})</h4>
                                            <button
                                              type="button"
                                              title="Print all box labels"
                                              aria-label="Print all box labels"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                if (arrayHasItems(product.boxes)) {
                                                  setPrintingList([...printingList, product.id]);
                                                  handlePrintProductBoxes(shipment.id, product.id, product.boxes);
                                                }
                                              }}
                                              className="absolute top-1/2 transform -translate-y-1/2 -right-10 rounded p-1 text-gray-500 hover:text-gray-900 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-400 disabled:text-gray-300 disabled:cursor-not-allowed"
                                            >
                                              {printingList.includes(product.id) ? <ArrowPathIcon className="animate-spin h-4 w-4" /> : <PrinterIcon className="h-4 w-4" aria-hidden="true" />}
                                            </button>
                                          </div>
                                          <div>
                                            {access === "edit" && (
                                              <button
                                                onClick={() => {
                                                  if (arrayHasItems(product.boxes)) {
                                                    setReceiveAllTarget({ type: 'boxes', product });
                                                  }
                                                }}
                                                className="ml-2 inline-flex h-7 items-center rounded-md border border-gray-200 bg-white px-2 text-xs font-medium hover:bg-gray-900 hover:text-white"
                                              >
                                                Receive All
                                              </button>
                                            )}
                                          </div>
                                          <ReceivedQtyBarGraph products={[product]} />
                                        </div>
                                        <div className="overflow-hidden rounded-md border border-gray-200 bg-white">
                                          <table className="min-w-full divide-y divide-gray-200">
                                              <thead className="bg-transparent">
                                              <tr>
                                                {access === "edit" && (
                                                  <th colSpan="1" className="px-3 py-2 text-left text-[11px] uppercase tracking-wide text-gray-500">
                                                    <input
                                                      type="checkbox"
                                                      onClick={(e) => e.stopPropagation()}
                                                      checked={
                                                        arrayHasItems(product.boxes) &&
                                                        product.boxes
                                                          .filter((box) => box && box.id != null)
                                                          .every((box) =>
                                                            selectedBulkBoxes.some((selected) => selected.id === box.id)
                                                          )
                                                      }
                                                      onChange={(e) => {
                                                        e.stopPropagation();
                                                        const validBoxes = (product.boxes || []).filter((box) => box && box.id != null);
                                                        const allSelected = validBoxes.every((box) =>
                                                          selectedBulkBoxes.some((selected) => selected.id === box.id)
                                                        );
                                                        if (allSelected) {
                                                          setSelectedBulkBoxes((prev) =>
                                                            prev.filter(
                                                              (selected) =>
                                                                !validBoxes.some((box) => box.id === selected.id)
                                                            )
                                                          );
                                                        } else {
                                                          const newBoxes = validBoxes.filter(
                                                            (box) =>
                                                              !selectedBulkBoxes.some((selected) => selected.id === box.id)
                                                          );
                                                          setSelectedBulkBoxes((prev) => [...prev, ...newBoxes]);
                                                        }
                                                      }}
                                                      disabled={!arrayHasItems(product.boxes)}
                                                      className="w-5 h-5"
                                                    />
                                                  </th>
                                                )}
                                                <th scope="col" className="px-3 py-2 text-left text-[11px] uppercase tracking-wide text-gray-500">Box #</th>
                                                <th scope="col" className="px-3 py-2 text-left text-[11px] uppercase tracking-wide text-gray-500">Shipping Method</th>
                                                <th scope="col" className="px-3 py-2 text-left text-[11px] uppercase tracking-wide text-gray-500">Tracking Number</th>
                                                <th scope="col" className="px-3 py-2 text-left text-[11px] uppercase tracking-wide text-gray-500">Date Shipped</th>
                                                <th scope="col" className="px-3 py-2 text-left text-[11px] uppercase tracking-wide text-gray-500">Est. Receive Date</th>
                                                <th scope="col" className="relative px-3 py-2 text-left text-[11px] uppercase tracking-wide text-gray-500">
                                                  <span className="flex text-green-600 items-center justify-left h-[40px] text-xs px-6 absolute -translate-x-1/2 left-1/2 w-full min-w-[140px] -top-10 text-left">{product.rangeActualDateByProduct || ""}</span>
                                                  Received Date
                                                </th>
                                                <th scope="col" className="px-3 py-2 text-left text-[11px] uppercase tracking-wide text-gray-500">Landed Cost</th>
                                                <th scope="col" className="px-3 py-2 text-left text-[11px] uppercase tracking-wide text-gray-500">Received / Shipped / Ordered Qty</th>
                                                <th scope="col" className="px-3 py-2 text-left text-[11px] uppercase tracking-wide text-gray-500">Actions</th>
                                              </tr>
                                            </thead>
                                            <tbody className="bg-white divide-y divide-gray-200">
                                              {(product.boxes || []).map((box, index) => {
                                                const receivedDate = editedBoxes[box.id]?.actualDate !== undefined
                                                  ? editedBoxes[box.id].actualDate
                                                  : box.actualDate || "";
                                                const dateShipped = editedBoxes[box.id]?.dateShipped !== undefined
                                                  ? editedBoxes[box.id]?.dateShipped
                                                  : box.dateShipped
                                                    ? box.dateShipped
                                                    : "";
                                                const received = editedBoxes[box.id]?.receivedQuantity !== undefined
                                                  ? editedBoxes[box.id]?.receivedQuantity
                                                  : box.receivedQuantity || 0;
                                                const shipped = editedBoxes[box.id]?.shippedQuantity !== undefined
                                                  ? editedBoxes[box.id]?.shippedQuantity
                                                  : box.shippedQuantity || 0;
                                                const shippedQuantityIsManual = editedBoxes[box.id]?.shippedQuantityIsManual !== undefined
                                                  ? editedBoxes[box.id]?.shippedQuantityIsManual
                                                  : box.shippedQuantityIsManual || false;
                                                return (
                                                  <tr key={`${box.id}_${index}`} className="border-t border-gray-200">
                                                    {access === "edit" && (
                                                      <td className="py-2 px-4 text-sm text-center">
                                                        <input
                                                          type="checkbox"
                                                          checked={selectedBulkBoxes.some((p) => p.id === box.id)}
                                                          onClick={(e) => e.stopPropagation()}
                                                          onChange={(e) => {
                                                            e.stopPropagation();
                                                            setSelectedBulkBoxes((prev) => {
                                                              const isAlreadySelected = prev.some((p) => p.id === box.id);
                                                              if (isAlreadySelected) {
                                                                return prev.filter((p) => p.id !== box.id);
                                                              } else {
                                                                return [...prev, box];
                                                              }
                                                            });
                                                          }}
                                                          className="w-5 h-5"
                                                        />
                                                      </td>
                                                    )}
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{currentShipmentBoxIds[shipment.id][product.id][box.id]}</td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                      <select
                                                        value={
                                                          editedBoxes[box.id]?.shippingMethod !== undefined
                                                            ? editedBoxes[box.id]?.shippingMethod
                                                            : box.shippingMethod ? box.shippingMethod
                                                              : ""
                                                        }
                                                        onChange={(e) => {
                                                          if (access === "edit") {
                                                            setEditedBoxes({
                                                              ...editedBoxes,
                                                              [box.id]: {
                                                                ...(editedBoxes[box.id] || box),
                                                                shippingMethod: e.target.value
                                                              }
                                                            })
                                                          }
                                                        }}
                                                        disabled={access !== "edit"}
                                                        data-testid={testId ? `box-select-${index}-productid-${product.id}-${testId}` : undefined}
                                                        className={`block disabled:bg-gray-200 w-full py-1 px-2 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-xs ${getShippingMethodColor(box.shippingMethod)}`}
                                                      >
                                                        <option value={null} className="bg-gray-100 text-gray-800"></option>
                                                        <option value={SEA} className="bg-blue-100 text-blue-800">{enumBoxTypes[SEA]}</option>
                                                        <option value={AIR} className="bg-indigo-100 text-indigo-800">{enumBoxTypes[AIR]}</option>
                                                      </select>
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 w-64">
                                                      <div className="flex items-center gap-2">
                                                        <input
                                                          type="text"
                                                          value={
                                                            editedBoxes[box.id]?.trackingNumber !== undefined
                                                              ? editedBoxes[box.id]?.trackingNumber
                                                              : box.trackingNumber
                                                                ? box.trackingNumber
                                                                : ""
                                                          }
                                                          onChange={(e) => {
                                                            if (access === "edit") {
                                                              setEditedBoxes({
                                                                ...editedBoxes,
                                                                [box.id]: {
                                                                  ...(editedBoxes[box.id] || box),
                                                                  trackingNumber: e.target.value
                                                                }
                                                              })
                                                            }
                                                          }}
                                                          disabled={access !== "edit"}
                                                          data-testid={testId ? `box-trackingNumber-${index}-productid-${product.id}-${testId}` : undefined}
                                                          className="w-60 disabled:bg-gray-200 py-0.5 px-2 shadow-sm border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                                        />
                                                        {box.trackingNumber && (
                                                          <a href={`https://www.ups.com/track?track=yes&trackNums=${box.trackingNumber}&loc=en_US&requester=ST/trackdetails`} target="_blank">
                                                            <LinkIcon className="h-4 w-4 cursor-pointer fill-blue-500 hover:fill-blue-900" aria-hidden="true" />
                                                          </a>
                                                        )}
                                                      </div>
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                      <div className="relative w-44">
                                                        <BoxDate
                                                          key={dateShipped}
                                                          box={box}
                                                          access={access}
                                                          date={dateShipped}
                                                          formattedDate={box.formattedShippedDate}
                                                          setEditedBoxes={setEditedBoxes}
                                                          testId={`box-actual-date-${index}-productid-${product.id}-${testId}`}
                                                          editedBoxes={editedBoxes}
                                                          keyDate={"dateShipped"}
                                                        />
                                                        {dateShipped && (
                                                          <DocumentDuplicateIcon 
                                                            className="h-5 w-5 cursor-pointer absolute right-0 -translate-y-1/2 top-1/2 text-gray-500 hover:text-gray-400" 
                                                            onClick={() => {
                                                              const formatted = formatDateForInput(dateShipped);
                                                              if (formatted) {
                                                                navigator.clipboard.writeText(formatted);
                                                              }
                                                            }}
                                                          />
                                                        )}
                                                      </div>
                                                      {/* <span>{box.dateShipped || "N/A"}</span> */}
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                      {/* <input
                                                        type="date"
                                                        readOnly
                                                        value={editedBoxes[box.id]?.estimatedReceiveDate || box.estimatedReceiveDate}
                                                        onChange={(e) => {
                                                          setEditedBoxes({
                                                            ...editedBoxes,
                                                            [box.id]: {
                                                              ...(editedBoxes[box.id] || box),
                                                              estimatedReceiveDate: e.target.value
                                                            }
                                                          })
                                                        }}
                                                        className="w-full py-0.5 px-2 shadow-sm border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                                      /> */}
                                                      <span>
                                                        {getEstimatedReceiveDateLabel({
                                                          explicitDate: box.estimatedReceiveDate,
                                                          edited: editedBoxes[box.id],
                                                          shippingMethod: box.shippingMethod,
                                                          dateShipped: box.dateShipped,
                                                          resolvedDate: box.resolvedEstimatedReceiveDate,
                                                          poEstimatedDeliveryDate: shipment.estimatedDeliveryDate,
                                                        })}
                                                      </span>
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                      <div className="relative w-44">
                                                        <BoxDate
                                                          key={receivedDate}
                                                          box={box}
                                                          access={access}
                                                          date={receivedDate}
                                                          formattedDate={box.formattedActualDate}
                                                          setEditedBoxes={setEditedBoxes}
                                                          testId={`box-actual-date-${index}-productid-${product.id}-${testId}`}
                                                          editedBoxes={editedBoxes}
                                                          keyDate={"actualDate"}
                                                        />
                                                        {receivedDate && (
                                                          <DocumentDuplicateIcon 
                                                            className="h-5 w-5 cursor-pointer absolute right-0 -translate-y-1/2 top-1/2 text-gray-500 hover:text-gray-400" 
                                                            onClick={() => {
                                                              const formatted = formatDateForInput(receivedDate);
                                                              if (formatted) {
                                                                navigator.clipboard.writeText(formatted);
                                                              }
                                                            }}
                                                          />
                                                        )}
                                                      </div>
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                      {box.landedCost ? `$${box.landedCost}` : "N/A"}
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                      <div className="flex items-center space-x-2">
                                                        <input
                                                          type="text"
                                                          value={received}
                                                          onChange={(e) => {
                                                            if (access === "edit") {
                                                              let newValue = e.target.value;
                                                              if (/^\d*$/.test(newValue)) {
                                                                if (newValue.startsWith('0') && newValue.length > 1) {
                                                                    newValue = newValue.replace(/^0+/, '');
                                                                }
                                                                setEditedBoxes({
                                                                  ...editedBoxes,
                                                                  [box.id]: {
                                                                    ...(editedBoxes[box.id] || box),
                                                                    receivedQuantity: Number(newValue || 0),
                                                                  }
                                                                });
                                                              }
                                                            }
                                                          }}
                                                          disabled={access !== "edit"}
                                                          data-testid={testId ? `box-receivedQuantity-${index}-productid-${product.id}-${testId}` : undefined}
                                                          className="w-14 disabled:bg-gray-200 py-0.5 px-2 shadow-sm border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                                        />
                                                        <span>/</span>
                                                        <input
                                                          type="text"
                                                          value={shipped}
                                                          onChange={(e) => {
                                                            if (access === "edit") {
                                                              let newValue = e.target.value;
                                                              if (/^\d*$/.test(newValue)) {
                                                                if (newValue.startsWith('0') && newValue.length > 1) {
                                                                    newValue = newValue.replace(/^0+/, '');
                                                                }
                                                                setEditedBoxes({
                                                                  ...editedBoxes,
                                                                  [box.id]: {
                                                                    ...(editedBoxes[box.id] || box),
                                                                    shippedQuantity: Number(newValue || 0),
                                                                    shippedQuantityIsManual: true
                                                                  }
                                                                });
                                                              }
                                                            }
                                                          }}
                                                          disabled={access !== "edit"}
                                                          data-testid={testId ? `box-receivedQuantity-${index}-productid-${product.id}-${testId}` : undefined}
                                                          className="w-14 disabled:bg-gray-200 py-0.5 px-2 shadow-sm border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                                        />
                                                        <span>/</span>
                                                        <span>{box.quantity}</span>
                                                        <div className="flex items-center">
                                                          <input
                                                            type="checkbox"
                                                            id={`full-quantity-${box.id}`}
                                                            checked={Number(editedBoxes[box.id]?.receivedQuantity || box.receivedQuantity) >= box.quantity}
                                                            onChange={(e) => {
                                                              if (access === "edit") {
                                                                setEditedBoxes({
                                                                  ...editedBoxes,
                                                                  [box.id]: {
                                                                    ...(editedBoxes[box.id] || box),
                                                                    receivedQuantity: box.quantity,
                                                                  }
                                                                })
                                                              }
                                                            }}
                                                            disabled={access !== "edit"}
                                                            data-testid={testId ? `box-checkbox-${index}-productid-${product.id}-${testId}` : undefined}
                                                            className="h-4 disabled:bg-gray-200 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                                                          />
                                                          <label htmlFor={`full-quantity-${box.id}`} className="ml-2 text-sm text-gray-600">
                                                            Full Qty
                                                          </label>
                                                        </div>
                                                      </div>
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                      <div className="flex items-center gap-3">
                                                        {editedBoxes[box.id] && access === "edit" && (
                                                          <div className="flex flex-row gap-2">
                                                            <button
                                                              onClick={async () => {
                                                                if (testId) {
                                                                  console.log("Submit box changes!")
                                                                  return
                                                                }
                                                                try {
                                                                  const editedBoxData = { ...editedBoxes[box.id], shippingMethod: editedBoxes[box.id]?.shippingMethod || null }
                                                                  await dispatch(
                                                                    updateBox({
                                                                      boxes: [editedBoxData],
                                                                      ...listParams,
                                                                    })
                                                                  ).unwrap();
                                                                  const filteredObj = filterKeyFromObject(editedBoxes, box.id);
                                                                  setEditedBoxes({
                                                                    ...filteredObj,
                                                                  });
                                                                } catch (error) {
                                                                  console.error("Error updating box:", error);
                                                                }
                                                              }}
                                                              data-testid={testId ? `submit-changes-button-${box.id}-${testId}` : undefined}
                                                              className="inline-flex items-center px-3 py-1.5 border border-transparent rounded shadow-sm text-white bg-green-500 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                                            >
                                                              <CheckIcon className="h-4 w-4" aria-hidden="true" />
                                                            </button>
                                                            <button
                                                              onClick={() => {
                                                                if (testId) {
                                                                  console.log("Cancel box changes!")
                                                                  return
                                                                }
                                                                const filteredObj = filterKeyFromObject(editedBoxes, box.id)
                                                                setEditedBoxes({
                                                                  ...filteredObj,
                                                                })
                                                              }}
                                                              data-testid={testId ? `cancel-changes-button-${box.id}-${testId}` : undefined}
                                                              className="inline-flex items-center px-3 py-1.5 border border-transparent rounded shadow-sm text-white bg-red-500 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                                            >
                                                              <XMarkIcon className="h-4 w-4" aria-hidden="true" />
                                                            </button>
                                                          </div>
                                                        )}
                                                        {!editedBoxes[box.id] && (
                                                          <button
                                                            type="button"
                                                            title="Print label(s)"
                                                            aria-label="Print label(s)"
                                                            onClick={(e) => {
                                                              e.stopPropagation();
                                                              setPrintingList([...printingList, box.id]);
                                                              handlePrint({
                                                                id: box.id,
                                                                boxIdToPrint: currentShipmentBoxIds[shipment.id][product.id][box.id]
                                                              });
                                                            }}
                                                            className="rounded p-1 text-gray-500 hover:text-gray-900 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-400 disabled:text-gray-300 disabled:cursor-not-allowed"
                                                          >
                                                            {printIsLoading && printingList.includes(box.id) ? <ArrowPathIcon className="animate-spin h-4 w-4" /> : <PrinterIcon className="h-4 w-4" aria-hidden="true" />}
                                                          </button>
                                                        )}
                                                        {!editedBoxes[box.id] && access === "edit" && (
                                                          <button
                                                            type="button"
                                                            title="Delete box"
                                                            aria-label="Delete box"
                                                            className="rounded p-1 text-gray-500 hover:text-red-600 hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-red-300 disabled:opacity-50"
                                                            onClick={(e) => {
                                                              e.stopPropagation();
                                                              setBoxIdToDelete(box.id);
                                                              setDeleteModalOpened(true);
                                                            }}
                                                          >
                                                            {(isDeleteBoxLoading() && boxIdToDelete === box.id) ? (
                                                              <ArrowPathIcon className="animate-spin h-4 w-4" />
                                                            ) : (
                                                              <TrashIcon className="h-4 w-4" aria-hidden="true" />
                                                            )}
                                                          </button>
                                                        )}
                                                      </div>
                                                    </td>
                                                  </tr>
                                                )
                                              })}
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    );
                                  })}
                                </>
                              )}
                            </td>
                          </tr>
                        )}
                        {/* Add a spacer row */}
                        <tr className="h-2 bg-gray-100">
                          <td colSpan="7"></td>
                        </tr>
                      </React.Fragment>
                    )
                  })
                ) : (
                  currentIsFirstLoadComplete && (
                    <tr>
                      <td colSpan="7" className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-center">
                        No shipments match the current filters. Try adjusting your search or filter criteria.
                      </td>
                    </tr>
                  )
                )}
              </tbody>
            </table>
            </div>
          </div>
          {!currentIsFirstLoadComplete && (
            <div className="z-10 h-60">
              <LoaderSpinner width='70' height='70' border='3' colorSpinner='black' testId={testId ? `loader-table-${testId}` : undefined} />
            </div>
          )}
        </div>
        {currentIsFirstLoadComplete && (
          <div className="mt-6 mb-4">
            <Pagination
              currentItemsPerPage={currentItemsPerPage}
              rangeRows={pagination.rangeRows}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              isTheLastPage={pagination.isTheLastPage}
              totalPages={pagination.totalPages}
              setCurrentItemsPerPage={setCurrentItemsPerPage}
            />
          </div>
        )}
        <ConfrimModal
          isOpen={Boolean(receiveAllTarget)}
          title="Receive all?"
          description={
            receiveAllTarget?.type === 'boxes'
              ? `This will mark all ${receiveAllTarget.product.boxes.length} boxes for ${receiveAllTarget.product.name || 'this product'} as received in full (${receiveAllTarget.product.boxes.reduce((total, box) => total + Number(box.quantity || 0), 0)} units). Continue?`
              : receiveAllTarget
                ? `This will mark all items in container ${receiveAllTarget.container.name || receiveAllTarget.container.id} as received in full (${receiveAllTarget.container.items.reduce((total, item) => total + Number(item.quantity || 0), 0)} units). Continue?`
                : ''
          }
          confirmButtonTitle="Receive All"
          isLoading={receiveAllIsLoading()}
          submitClick={submitReceiveAll}
          cancelClick={() => setReceiveAllTarget(null)}
          testId="receive-all-confirmation"
        />
        <ConfrimModal
          isOpen={deleteModalOpened}
          title={"Are you sure want to delete this box?"}
          confirmButtonTitle={"Delete"}
          isLoading={isDeleteBoxLoading()}
          submitClick={async () => {
            setDeleteModalOpened(false)
            await dispatch(deleteBox({ id: boxIdToDelete, ...listParams }))
            setBoxIdToDelete("")
          }}
          cancelClick={() => {
            setDeleteModalOpened(false)
            setBoxIdToDelete("")
          }}
        />
        <ConfrimModal
          isOpen={deleteContainerModalOpened}
          title={"Are you sure want to delete this container?"}
          confirmButtonTitle={"Delete"}
          isLoading={isDeleteContainerLoading()}
          submitClick={async () => {
            setDeleteContainerModalOpened(false)
            await dispatch(deleteContainer({ 
              id: containerToDelete,
              ...listParams,
            }))
            setContainerToDelete("")
          }}
          cancelClick={() => {
            setDeleteContainerModalOpened(false)
            setContainerToDelete("")
          }}
        />

        <ConfrimModal
          isOpen={deleteShipmentModalOpened}
          title={"Are you sure want to delete this shipment?"}
          confirmButtonTitle={"Delete"}
          isLoading={isDeleteBoxLoading()}
          submitClick={async () => {
            setDeleteShipmentModalOpened(false)
            await dispatch(deleteShipment({ id: shipmentToDelete, ...listParams }))
            setShipmentToDelete("")
          }}
          cancelClick={() => {
            setDeleteShipmentModalOpened(false)
            setShipmentToDelete("")
          }}
        />

        <ConfrimModal
          isOpen={syncConfirmModalOpened}
          title={"Are you sure want to sync this PO?"}
          isLoading={syncIsLoading()}
          confirmButtonTitle={"Sync"}
          submitClick={async () => {
            setSyncShipmentId("");
            setSyncConfirmModalOpened(false);
            await dispatch(syncShipment({ id: syncShipmentId }));
          }}
          cancelClick={() => {
            setSyncShipmentId("");
            setSyncConfirmModalOpened(false);
          }}
        />

        {/* Updated Create Shipment Modal */}
        {isModalOpen && (
          <CreateShipping
            handleSubmit={handleSubmitShipment}
            setIsModalOpen={setIsModalOpen}
          />
        )}
        {isContainerOpen && (
          <CreateContainerByShipping
            handleSubmit={handleSubmitContainer}
            setIsContainerOpen={setIsContainerOpen}
            existingContainer={existingContainer}
          />
        )}

        <ShippingBulkEditModal
          isOpen={openedBulkEditModal}
          onClose={() => setOpenedBulkEditModal(false)}
          boxes={selectedBulkBoxes}
          onAcceptActions={async (data) => {
            await dispatch(updateBoxes({
              ...data,
              boxesIds: (selectedBulkBoxes || []).map((box) => box.id)
            }));
            fetchShipmentsData();
            setSelectedBulkBoxes([]);
            setOpenedBulkEditModal(false);
          }}
        />

        <ShipmentChangeHistoryDrawer
          isOpen={shipmentHistoryOpen}
          onClose={() => setShipmentHistoryOpen(false)}
          marginFromSidebar={marginFromSidebar}
          onChanged={fetchShipmentsData}
          refreshToken={shipmentHistoryRefreshToken}
        />

        <ConfrimModal
          isOpen={undoShipmentModalOpen}
          title="Undo last change?"
          description="This reverts the most recent shipping change batch."
          confirmButtonTitle="Undo"
          isLoading={undoShipmentIsLoading()}
          submitClick={submitUndoShipment}
          cancelClick={() => {
            if (!undoShipmentIsLoading()) setUndoShipmentModalOpen(false);
          }}
        />

      </main>
    </>
  );
}

export default Shipping;